module Bookhus.SearchWidget {
    export class LocalizedSearchValues {
        private translations: any = {
            AntalPersoner: {
                da: "Antal personer",
                "en-GB": "Number of persons",
                de: "Anzahl der Personen",
                sv: "Antal personer",
                no: "Antall personer"
            },
            AntalSoveværelser: {
                da: "Antal soveværelser",
                "en-GB": "Number of bedrooms",
                de: "Anzahl der Schlafzimmer",
                sv: "Antal rum",
                no: "Antall rom"
            },
            Bjergby: {
                da: "Bjergby",
                "en-GB": "Mountain city",
                de: "Bergstadt",
                sv: "Bergstad",
                no: "Fjellby"
            },
            Brændeovn: {
                da: "Brændeovn",
                "en-GB": "Wood stove",
                de: "Holzofen",
                sv: "Vedeldad spis",
                no: "Vedovn"
            },
            Boat: {
                da: "Båd",
                "en-GB": "Boat",
                de: "Boot",
                sv: "Båt",
                no: "Båt"
            },
            Cykler: {
                da: "Cykler",
                "en-GB": "Cycles",
                de: "Fahrräder",
                sv: "Cyklar",
                no: "Sykler"
            },
            Dag: {
                da: "dag",
                "en-GB": "Day",
                de: "Tag",
                sv: "dag",
                no: "dag"
            },
            Dage: {
                da: "dage",
                "en-GB": "Days",
                de: "Tage",
                sv: "dagar",
                no: "dager"
            },
            Ekkolod: {
                da: "Ekkolod",
                "en-GB": "Sonar",
                de: "Sonar",
                sv: "Ekolod",
                no: "Ekkolodd"
            },
            Faciliteter: {
                da: "Faciliteter",
                "en-GB": "Facilities",
                de: "Einrichtungen",
                sv: "Faciliteter",
                no: "Fasiliteter"
            },
            Feriecenter: {
                da: "Feriecenter",
                "en-GB": "",
                de: "Ferienzentrum",
                sv: "Semestercenter",
                no: "Feriesenter"
            },
            Fiskerenseplads: {
                da: "Fiskerenseplads",
                "en-GB": "Fish cleaning table",
                de: "Fischreinigungs",
                sv: "Fiskrensbord",
                no: "Sløye"
            },
            Garage: {
                da: "Garage",
                "en-GB": "Garage",
                de: "Garage",
                sv: "Garage",
                no: "Garasje"
            },
            Handicapvenligt: {
                da: "Handicapvenligt",
                "en-GB": "Disabled friendly",
                de: "Behindertengerecht",
                sv: "Handikappvänlig",
                no: "Hendicapvenligt"
            },
            HavDistance: {
                da: "Afstand til havet",
                "en-GB": "Distance to the sea",
                de: "Nähe zum Meer",
                sv: "Avstånd till havet",
                no: "Avstand til sjøen"
            },
            Havudsigt: {
                da: "Havudsigt",
                "en-GB": "Sea views",
                de: "Meerblick",
                sv: "Havsutsikt",
                no: "Sjø"
            },
            Hus: {
                da: "Hus",
                "en-GB": "House",
                de: "Haus",
                sv: "Hus",
                no: "Hus"
            },
            Husdyr: {
                da: "Husdyr",
                "en-GB": "Pets",
                de: "Haustiere",
                sv: "Husdjur",
                no: "Husdyr"
            },
            HusdyrIkkeTilladt: {
                da: "Ingen husdyr tilladt",
                "en-GB": "Pets not allowed",
                de: "Haustiere nicht erlaubt",
                sv: "Husdjur inte tillåtna",
                no: "Husdyr ikke tillatt"
            },
            IkkeValgt: {
                da: "Ikke valgt",
                "en-GB": "Not selected",
                de: "Nicht ausgewählt",
                sv: "Inte vald",
                no: "Ikke valgt"
            },
            PoolIn: {
                da: "Indendørs pool",
                "en-GB": "Indoor pool",
                de: "Hallenbad",
                sv: "Inomhuspool",
                no: "Innendørs basseng"
            },
            Internet: {
                da: "Internet",
                "en-GB": "Internet",
                de: "Internet",
                sv: "Internet",
                no: "Internett"
            },
            KøbmandDistance: {
                da: "Afstand til købmanden",
                "en-GB": "Distance to the merchant",
                de: "Entfernung zum Lebensmittelgeschäft",
                sv: "Avstånd till köpman",
                no: "Avstand til matbutikk"
            },
            Lejlighed: {
                da: "Lejlighed",
                "en-GB": "Apartment",
                de: "Wohnung",
                sv: "Lägenhet",
                no: "Leilighet"
            },
            Lokation: {
                da: "Alle steder",
                "en-GB": "All locations",
                de: "Überall",
                sv: "Alla platser",
                no: "Alle steder"
            },
            Beliggenhed: {
                da: "Beliggenhed",
                "en-GB": "Location",
                de: "Lage",
                sv: "Plats",
                no: "Plassering"
            },
            Mikroovn: {
                da: "Mikroovn",
                "en-GB": "Mircowave",
                de: "Mikrowelle",
                sv: "Mikrovågsugn",
                no: "Mikrobølgeovn"
            },
            Nulstil: {
                da: "Nulstil",
                "en-GB": "Reset",
                de: "rücksetzen",
                sv: "Återståll",
                no: "Tilbakestille"
            },
            Område: {
                da: "Område",
                "en-GB": "Area",
                de: "Bereich",
                sv: "Område",
                no: "Område"
            },
            Opvaskemaskine: {
                da: "Opvaskemaskine",
                "en-GB": "Dishwasher",
                de: "Spülmaschine",
                sv: "Diskmaskin",
                no: "Oppvaskmaskin"
            },
            Parabol: {
                da: "Parabol",
                "en-GB": "Satellite",
                de: "Sat. Anschluss",
                sv: "Parabol",
                no: "Parabol"
            },
            Periode: {
                da: "Periode",
                "en-GB": "Period",
                de: "Zeit",
                sv: "Period",
                no: "Periode"
            },
            Person: {
                da: "Person",
                "en-GB": "Person",
                de: "Person",
                sv: "Person",
                no: "Person"
            },
            Personer: {
                da: "Personer",
                "en-GB": "Persons",
                de: "Leute",
                sv: "Människor",
                no: "Mennesker"
            },
            Radar: {
                da: "Radar",
                "en-GB": "Radar",
                de: "Radar",
                sv: "Radar",
                no: "Radar"
            },
            VhsRadio: {
                da: "Vhs radio",
                "en-GB": "Vhs radio",
                de: "Vhs radio",
                sv: "Vhs radio",
                no: "Vhs radio"
            },
            Rygning: {
                da: "Rygning",
                "en-GB": "Smoking",
                de: "Rauchen",
                sv: "Rökning",
                no: "Røyking"
            },
            Sauna: {
                da: "Sauna",
                "en-GB": "Sauna",
                de: "Sauna",
                sv: "Bastu",
                no: "Badstue"
            },
            Skiområde: {
                da: "Skiområde",
                "en-GB": "Ski area",
                de: "Skigebiet",
                sv: "Skidområde",
                no: "Skiområde"
            },
            Spa: {
                da: "Spa",
                "en-GB": "Spa",
                de: "Whirrlpool",
                sv: "Spa",
                no: "Spa"
            },
            StartDato: {
                da: "Startdato",
                "en-GB": "Startdate",
                de: "Startdatum",
                sv: "Startdatum",
                no: "Startdato"
            },
            Storby: {
                da: "Storby",
                "en-GB": "City",
                de: "Große stadt",
                sv: "Storstad",
                no: "Storby"
            },
            Swimmingpool: {
                da: "Svømmebassin",
                "en-GB": "Swimmingpool",
                de: "Schwimmbad",
                sv: "Simbassäng",
                no: "Svømmebasseng"
            },
            Search: {
                da: "Søg",
                "en-GB": "Search",
                de: "Suche",
                sv: "Sök",
                no: "Søk"
            },
            MinTwoToilets: {
                da: "2. toiletter",
                "en-GB": "2. toilets",
                de: "2. Toiletten",
                sv: "2. toaletter",
                no: "2. toaletter"
            },
            Tørretumbler: {
                da: "Tørretumbler",
                "en-GB": "Dryer",
                de: "Trockner",
                sv: "Torktumlare",
                no: "Tørketrommel"
            },
            PoolOut: {
                da: "Udendørs pool",
                "en-GB": "Outdoor pool",
                de: "Freibad",
                sv: "Utomhuspool",
                no: "Utendørs basseng"
            },
            UdsigtNatur: {
                da: "Natur udsigt",
                "en-GB": "Nature view",
                de: "",
                sv: "Naturvyn",
                no: "Naturutsikt"
            },
            LadeStander: {
                da: "Lade stander",
                "en-GB": "Charging station",
                de: "Ladestation",
                sv: "Laddstation",
                no: "Ladestasjon"
            },
            Varmepumpe: {
                da: "Varmepumpe",
                "en-GB": "Heat pump",
                de: "Wärmepumpe",
                sv: "Värmepump",
                no: "Varmepumpe"
            },
            UdsigtVand: {
                da: "Vandudsigt",
                "en-GB": "Water view",
                de: "",
                sv: "Vatten visa",
                no: "Vannutsikt"
            },
            Uge: {
                da: "Uge",
                "en-GB": "Week",
                de: "Woche",
                sv: "Vecka",
                no: "Uke"
            },
            Uger: {
                da: "Uger",
                "en-GB": "Weeks",
                de: "Wochen",
                sv: "Veckor",
                no: "Uker"
            },
            Under: {
                da: "Under",
                "en-GB": "Under",
                de: "Unter",
                sv: "Nedan",
                no: "Under"
            },
            Vaskemaskine: {
                da: "Vaskemaskine",
                "en-GB": "Washing machine",
                de: "Waschmachine",
                sv: "Tvättmaskin",
                no: "Vaskemaskine"
            },
            VisKatalog: {
                da: "Vis i katalog",
                "en-GB": "Show in catalog",
                de: "In Katalog",
                sv: "Visa i katalogen",
                no: "Vis i katalog"
            },
            Værelse: {
                da: "Værelse",
                "en-GB": "Room",
                de: "Zimmer",
                sv: "Rum",
                no: "Rom"
            },
            Værelser: {
                da: "Værelser",
                "en-GB": "Rooms",
                de: "Zimmer",
                sv: "Rum",
                no: "Rom"
            },
            AdvancedSearch: {
                da: "Avanceret søgning",
                "en-GB": "Advanced search",
                de: "erweiterte Suche",
                sv: "avancerad sökning",
                no: "avansert søk"
            },
            SearchProperties: {
                da: "Søgeegenskaber",
                "en-GB": "Search properties",
                de: "Sucheigenschaften",
                sv: "Sökegenskaper",
                no: "Søkeegenskaper"
            },
            Where: {
                da: "Hvor",
                "en-GB": "Where",
                de: "Wo",
                sv: "Var",
                no: "Hvor"
            },
            When: {
                da: "Hvornår",
                "en-GB": "When",
                de: "Wann",
                sv: "När",
                no: "Når"
            },
            RoomAndGuest: {
                da: "Værelser og gæster",
                "en-GB": "Rooms & Guests",
                de: "Zimmer & Gäste",
                sv: "Rum & gäster",
                no: "Rom og gjester"
            },
            PropertyList: {
                da: "Emneliste",
                "en-GB": "Propertylist",
                de: "Objektliste",
                sv: "Fastighetslista",
                no: "Eiendomsliste"
            },
            ChooseALocation: {
                da: "Vælg en lokation",
                "en-GB": "Choose a location",
                de: "Wählen Sie einen Standort",
                sv: "Välj en plats",
                no: "Velg en lokasjon"
            },
            ChoosenLocations: {
                "da": "Valgt: {0}",
                "en-GB": "Chosen: {0}",
                "de": "Gewählt: {0}",
                "sv": "Vald: {0}",
                "no": "Valgt: {0}"
            },
            ChoosenMultipleLocations: {
                "da": "Valgt: {0} og {1} mere",
                "en-GB": "Chosen: {0} and {1} more",
                "de": "Gewählt: {0} und {1} weitere",
                "sv": "Vald: {0} och {1} mer",
                "no": "Valgt: {0} og {1} til"
            },
            ChooseTags: {
                "da": "Vælg tags",
                "en-GB": "Choose tags",
                "de": "Wählen tags",
                "sv": "Välja taggar",
                "no": "Velg tagger"
            }
        }

        get(name: string, lang?: string): string {

            if (this.translations[name] == undefined || this.translations[name] == null) {
                return "Oversættelse findes ikke";
            }

            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            var value = this.translations[name][langCode] || this.translations[name]["da"];
            if (value == undefined || value == "") {
                return "Oversættelse findes ikke";
            }
            return value;
        }
    }
}
